import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MasterData from '../../data/MasterData'
import { stationNumberClass } from '../../utils/ClassHelper'
import RestroomMasterData from '../../data/RestroomMasterData'

import home_images from '../../assets/images/home/*.svg'
import station_images from '../../assets/images/station_Info/*.svg'

const INCIDENT_HTML_URL = process.env.INCIDENT_HTML_URL
const BODY_CLASS = 'c-StationDetail'

class StationDetail extends React.Component {
  static propTypes = {
    lines: PropTypes.array.isRequired,
    fetchLines: PropTypes.func.isRequired,
    fetchTrains: PropTypes.func.isRequired,
    notifications: PropTypes.array.isRequired,
    closeStationDetail: PropTypes.func.isRequired,
  }

  async componentDidMount() {
    const { stationId } = this.props.match.params
    var { lineName } = this.props.match.params
    const { fetchLines, fetchTrains, fetchStationDetail, fetchNotifications } = this.props
    document.body.classList.add(BODY_CLASS)
    await fetchNotifications()

    if (this.props.lines.length === 0) {
      await fetchLines()
    }

    await fetchTrains()

    if (MasterData.isShiomibashiStation(stationId)) {　
      // 汐見橋線の駅は南海線としてダイヤ情報を取得する
      lineName = "nankai"
    }
    var updated_time = lineName == "nankai" ? this.props.nankai_update_time : this.props.koya_update_time
    var scheduleTypes = lineName == "nankai" ? this.props.nankai_scheduleTypes : this.props.koya_scheduleTypes    
    var lineId = lineName == "nankai" ? "1" : "2"    
    await fetchStationDetail(lineId, stationId, updated_time, scheduleTypes)

  }

  componentWillUnmount() {
    document.body.classList.remove(BODY_CLASS)
    this.props.closeStationDetail()
  }

  getTrainPositionPath(stationId) {
    // モーダルを閉じた場合、運行異常ダイアログは表示しないように showTrainOperationInfo=false クエリを付与する
    return MasterData.isOnNankaiLine(stationId) ? `/lines/nankai/trains?showTrainOperationInfo=false#station${stationId}` : `/lines/koya/trains?showTrainOperationInfo=false#station${stationId}`
  }

  closeModal(path) {
    this.props.history.push(path)
  }

  // ヘッダー
  renderHeader() {
    const { stationId } = this.props.match.params

    return (
      <div className="c-Modal-header">
        <p className="c-Modal-headerTitle">駅情報</p>
        <Link to={this.getTrainPositionPath(stationId)}>
          <div className="c-Modal-headerClose"></div>
        </Link>
      </div>
    )
  }

  lineKind() {
    const { stationId } = this.props.match.params
    return MasterData.lineKind(stationId)
  }

  lineNameJa() {
    const {
      stationId
    } = this.props.match.params
    switch (this.lineKind()) {
      case 'nankai':
        return '南海線'
      case 'takashinohama':
        return '高師浜線'
      case 'kuko':
        return '空港線'
      case 'tanagawa':
        return '多奈川線'
      case 'kada':
        return '加太線'
      case 'koya':
        return '高野線'
      case 'shiomibashi':
        return '汐見橋線'
      case 'senboku':
        return '泉北線'
      default:
        return ''
    }
  }

  stationNameUrl() {
    const { stationId } = this.props.match.params
    return MasterData.stationNameUrl(stationId)
  }

  // 発車時間の表示
  renderStationTimeTableRow(info, index, count) {
    const { lineName, stationId } = this.props.match.params
    if (index > count) return null

    var kind = ""
    if (lineName === "nankai") {
      kind = MasterData.nankaiTrainKindById(info.train_kind_code)
    } else {
      kind = MasterData.koyaTrainKindById(info.train_kind_code)
    }

    return (
      <li key={info.train_kind_code + info.departure_time} className="c-Modal-stationTimeTableRow">
        <div className="c-Modal-stationTimeTableCell -type-trainKind">
          <span className={`c-Modal-stationTrainKindIcon ${kind.kind}`}>
            <p>{kind.train_type}</p>
          </span>
        </div>
        <div className="c-Modal-stationTimeTableCell -type-transport">{info.arrival_station_name}行</div>
        <div className="c-Modal-stationTimeTableCell -type-arrival">{info.departure_time}</div>
        <div className="c-Modal-stationTimeTableCell -type-track">
          <span className="c-Modal-stationTrackNumber">{info.track_no}</span>番線
        </div>
      </li>
    )
  }

  renderStationTimeTableHeader(direction, link) {
    if (link.link.length > 0) {
      return (
        <div className="c-Modal-stationTimeTableHeader">{direction}<a href={link.link} target="_blank" className="c-Modal-stationTimeTableLink">>&nbsp;時刻表</a></div>
      )
    }
    else {
      return (
        <div className="c-Modal-stationTimeTableHeader">{direction}</div>
      )
    }
  }

  renderStationTimeTableBody(infos, depart_up, count, has_window) {
    var comment = "本日の運行は終了しました"
    if (!has_window) {
      comment = "時刻表は駅詳細をタップして、弊社ホームページ画面からご確認ください。"
    }

    let filteredInfos = null
    if (infos !== null) {
      filteredInfos = infos.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.departure_time === value.departure_time && t.track_no === value.track_no
        ))
      );
    }

    return (
      <div className="c-Modal-stationTimeTableBody">
        <ul className="c-Modal-stationTimeTable">
          {filteredInfos != null ? filteredInfos.map((info, index) => this.renderStationTimeTableRow(info, index, count)) : <p>情報取得中...</p>}
        </ul>

        <div className={`c-Modal-stationTimeTable -type-serviceEnd ${depart_up}`}>
          <p>{comment}</p>
        </div>
      </div>
    )
  }

  renderStopTrainList(kinds, kinds_en) {
    var list = []
    for(var i in kinds){
      list.push(<span key={i} className={`c-Modal-stopTrainItem is_${kinds_en[i]}`}>{kinds[i]}</span>)
    }
    return (
      <dd className="c-Modal-stopTrainList">
        {list}      
      </dd>
    )
  }

  renderTransferLineList(transfer) {
    var list = []
    if (!transfer) list.push(<span className="c-Modal-transferLineNoItem"></span>)

    for(var i in transfer){
      list.push(<span key={i} className="c-Modal-transferLineItem">{transfer[i]}</span>)
    }

    return (
      <dd className="c-Modal-transferLineList">
        {list}      
      </dd>
    )
  }

  renderStationDiaError() {
    const error_image = "home_error"

    return (
      <div className="c-Modal-stationDiaError">
        <div className="c-Modal-stationDiaErrorIcon">
          <img src={home_images[error_image]} />
        </div>
        <p className="c-Modal-stationDiaErrorText">
          こちらは定刻ダイヤの時刻を表示しています。<br/>
          運休や発車順の変更がある場合がありますので、<br/>
          詳しくは運行情報をご確認ください。
        </p>
      </div>
    )
  }

  // 駅情報の表示
  renderStationBody() {
    const { up, down, has_window, notifications } = this.props
    const { lines, lineName, stationId } = this.props.match.params

    const station =this.stations().find(station => station.id == stationId)

    if (!station) return null
    // APIから駅情報をとれたとき

    const ekiNumber = station.eki_number
    var stationNamePath = ""
    if (this.lineKind() === 'senboku'){
      stationNamePath = "station_senboku_stationnumber_sb"
    } else {
      stationNamePath = `station_${this.lineKind()}_stationnumber_nk`
    }
    const station_image = `${stationNamePath}${ekiNumber}`
    const error_image = "home_error"
    var delay_info = notifications.some(notification => notification.delay === true)

    var depart_up = ""
    var depart_down = ""
    var up_count = 2
    var down_count = 2
    var type = ""

    if (MasterData.isUpEdgeStation(stationId)) {
      down_count = 5
      depart_up = ""
      depart_down = ""
    } else if (MasterData.isDownEdgeStation(stationId)) {
      up_count = 5
      depart_up = ""
      depart_down = ""
    }

    if (up != null && up.length == 0) {
      depart_up = "is-show"
    }

    if (down != null && down.length == 0) {
      depart_down = "is-show"
    }

    if (delay_info){
      if (up_count == 2 && down_count == 2){
        up_count = up_count - 1
        down_count = down_count - 1  
      }
      type = "-type-error"
    }

    return (
      <div className="c-Modal-body">
        <div className="c-Modal-stationSummary">
          <div className="c-Modal-stationNumber">
            <img src={station_images[station_image]} />
          </div>
          <div className="c-Modal-stationSummaryInner">
            <p className="c-Modal-stationLineName">{this.lineNameJa()}</p>
            <p className="c-Modal-stationName">{station.name_ja}</p>
            <p className="c-Modal-stationNameEn">{station.name_en}</p>
          </div>
        </div>

        <dl className="c-Modal-stationStopTrains">
          <dt className="c-Modal-stopTrainLabel">停車種別：</dt>
          {this.renderStopTrainList(station.stop_train, station.stop_train_en)}
        </dl>

        <dl className="c-Modal-stationTransferLines">
          <dt className="c-Modal-transferLineLabel">乗換路線：</dt>
          {this.renderTransferLineList(station.transfer)}
        </dl>

        <div className={`c-Modal-stationDiaWrapper ${type}`}>
          <div className="c-Modal-stationDia">
            {down_count == 5 ? "" : this.renderStationTimeTableHeader(station.up_direction, MasterData.getTimeTableLink(stationId, "up"))}
            {down_count == 5 ? "" : this.renderStationTimeTableBody(up, depart_up, up_count, has_window)}

            {up_count == 5 ? "" : this.renderStationTimeTableHeader(station.down_direction, MasterData.getTimeTableLink(stationId, "down"))}
            {up_count == 5 ? "" : this.renderStationTimeTableBody(down, depart_down, down_count, has_window)}
          </div>
          {delay_info ? this.renderStationDiaError() : null}
        </div>
      </div>
    )
  }

  // フッター
  renderFooter() {
    const { stationId, lineName } = this.props.match.params

    var url = `http://www.nankai.co.jp/traffic/station/${this.stationNameUrl()}.html`
    const restRoomUrl = RestroomMasterData.linkUrl(lineName, stationId)
    return (
      <div className="c-Modal-footer">
        <div className="c-Modal-trainInfoFooterInner">
          <a href={url} className="c-Modal-trainInfoFooterLink">駅詳細</a>
          {
            restRoomUrl ? (
              <a href={restRoomUrl} className="c-Modal-trainInfoFooterLink">トイレ空き状況</a>
            )
            :(
              ''
            )
          }
        </div>
      </div>
    )
  }

  stations() {
    const { lines } = this.props
    const { lineName } = this.props.match.params
    const lineId = MasterData.lineIdByLineName(lineName)
    return lines.find(l => l.line_id === lineId).stations.concat(lines.find(l => l.line_id === lineId + 2).stations)
  }

  render() {
    const { lines } = this.props
    const { stationId } = this.props.match.params

    if (lines.length == 0) return null

    if (!stationId) return null

    return (
      <div
        className={`c-Modal is_${this.lineKind()}`}
        onClick={ () => this.closeModal(this.getTrainPositionPath(stationId)) }
      >
        <div
          className="c-Modal-dialog"
          onClick={(e) => e.stopPropagation()}
        >
          {this.renderHeader()}
          {this.renderStationBody()}
          {this.renderFooter()}
        </div>
      </div>
    )
  }
}

export default StationDetail
